const mutations = {
  UPDATE_USER_INFO(state, payload) {
    state.activeUser = payload;
    const user = JSON.stringify(payload);
    localStorage.setItem("authUser", user);
  },
  REMOVE_USER_INFO(state) {
    localStorage.removeItem("authUser");
    state.activeUser = {};
  }
};

export default mutations;
